import React from 'react'

import { BaseView, BaseText } from '@/components/base'
import { useTheme } from '@/hooks/useTheme'
import { ExpandableProps } from './types'

export const Expandable: React.FC<ExpandableProps> = ({
  expanded,
  children,
  initialHeight = 0,
  showTail = false,
}) => {
  const theme = useTheme()

  return (
    <div
      style={{
        height: expanded ? 'auto' : `${initialHeight}px`,
        overflow: expanded ? 'visible' : 'hidden',
        position: 'relative',
      }}
    >
      <div>{children}</div>

      {/* Show tail (ellipsis) when collapsed */}
      {!expanded && showTail && (
        <BaseView
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            backgroundColor: theme.colors.background.screen,
            paddingLeft: '8px',
            paddingRight: '3px',
            paddingTop: '3px',
            paddingBottom: '3px',
            borderRadius: '2px',
          }}
        >
          <BaseText fontSize={16} fontFamily="medium" color="label.description">
            ...
          </BaseText>
        </BaseView>
      )}
    </div>
  )
}
